import React from 'react';
import { useEditContext } from '@/contexts/EditContext.jsx';

const EditableField = ({ section, field, value, placeholder, multiline, className, as: Component = 'span' }) => {
  const { editMode, updateContent } = useEditContext();

  if (!editMode) {
    return <Component className={className}>{value}</Component>;
  }

  const handleChange = (e) => updateContent(section, field, e.target.value);
  const baseClass = `w-full bg-primary/10 border border-primary/50 rounded-md px-2 py-1 focus:ring-2 focus:ring-primary focus:outline-none text-foreground mix-blend-normal transition-colors ${className}`;

  if (multiline) {
    return (
      <textarea 
        value={value} 
        onChange={handleChange} 
        placeholder={placeholder} 
        className={`${baseClass} min-h-[80px] resize-y`} 
      />
    );
  }
  
  return (
    <input 
      type="text" 
      value={value} 
      onChange={handleChange} 
      placeholder={placeholder} 
      className={baseClass} 
    />
  );
};

export default EditableField;